import { Component, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePlaceholderDirective } from '../../../../core/directives/date-placeholder.directive';

export type ReportDateFilterMode = 'asOf' | 'range';

@Component({
  selector: 'ms-report-date-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, DatePlaceholderDirective],
  templateUrl: './report-date-filter.component.html',
  styleUrl: './report-date-filter.component.scss'
})
export class ReportDateFilterComponent {

  public mode = input<ReportDateFilterMode>('asOf');
  public asOfDate = model<string>('');
  public startDate = model<string>('');
  public endDate = model<string>('');
  public disabled = input<boolean>(false);

  public applied = output<void>();

  public onAsOfDateChanged(value: string): void {
    this.asOfDate.set(value);
    this.applied.emit();
  }

  public onStartDateChanged(value: string): void {
    this.startDate.set(value);
    this.applied.emit();
  }

  public onEndDateChanged(value: string): void {
    this.endDate.set(value);
    this.applied.emit();
  }
}
